/**
 * Region validation utilities
 *
 * Mirrors mobile's module-core/src/utils/region-validation.utils.ts
 */

import { RegionsStores } from '../static/regions-stores';
import type { StoreRegion } from '../modules/directories/constants/region.constants';

/**
 * Check if a shipping address region belongs to the same store as the current region
 */
export const isShippingRegionInSameStore = (
    currentRegion: StoreRegion | null | undefined,
    shippingRegionCode: string | null | undefined
): boolean => {
    if (!currentRegion || !shippingRegionCode) {
        return false;
    }

    const currentRegionData = RegionsStores.find(r => r.region_code === currentRegion.code);
    if (!currentRegionData) {
        return false;
    }

    const shippingRegionData = RegionsStores.find(r => r.region_code === shippingRegionCode);
    if (!shippingRegionData) {
        return false;
    }

    return currentRegionData.store_code === shippingRegionData.store_code;
};

/**
 * Get store configuration by region code
 */
export const getStoreConfigByRegionCode = (
    regionCode: string | null | undefined
): { store_code: string; scope: string; region_name: string } | undefined => {
    if (!regionCode) {
        return undefined;
    }
    const regionData = RegionsStores.find(r => r.region_code === regionCode);

    if (!regionData) {
        return undefined;
    }

    return {
        store_code: regionData.store_code,
        scope: regionData.scope,
        region_name: regionData.region_name,
    };
};
